import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "./Reveal";

const faqs = [
  {
    q: "La valutazione della bolletta è davvero gratuita?",
    a: "Sì. Analizziamo la tua bolletta e ti proponiamo l'offerta più conveniente senza alcun costo e senza impegno.",
  },
  {
    q: "Come posso inviarvi la mia bolletta?",
    a: "Direttamente dal form in questa pagina: carica il file (PDF o foto) della tua ultima bolletta luce o gas e pensiamo a tutto noi.",
  },
  {
    q: "Devo occuparmi io del cambio fornitore?",
    a: "No. Una volta scelta l'offerta, gestiamo noi tutta la procedura di attivazione e cambio fornitore. La fornitura non subisce interruzioni.",
  },
  {
    q: "Lavorate anche con aziende e partite IVA?",
    a: "Certo. Offriamo consulenza dedicata sia per i privati che per le imprese, con soluzioni su misura in base ai consumi.",
  },
  {
    q: "Che tipo di assistenza offrite dopo l'attivazione?",
    a: "Assistenza continua: resti seguito da un nostro riferimento per qualsiasi necessità, dalla lettura della bolletta alla gestione della fornitura.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32 scroll-mt-20"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <Reveal className="text-left">
          <span className="text-xs uppercase tracking-[0.2em] font-medium text-sage-600">
            Domande frequenti
          </span>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight leading-tight text-forest-900">
            Tutto quello che vuoi sapere.
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-sage-200"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-xl md:text-2xl text-forest-900 hover:text-forest-700 hover:no-underline transition-colors duration-300 py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base font-light text-forest-700 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
